import { css } from 'lit';

export const listPrefix = css`
  .hive-list-block__prefix {
    display: flex;
    color: var(--hive-blue-700);
    font-size: var(--hive-font-sm);
    user-select: none;
    position: relative;
  }

  .hive-list-block__numbered {
    min-width: 22px;
    height: 24px;
    margin-left: 2px;
  }

  .hive-list-block__todo-prefix {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 24px;
    height: 24px;
    color: var(--hive-icon-color);
  }

  .hive-list-block__todo-prefix.readonly {
    cursor: default;
  }

  .hive-list-block__todo-prefix > svg {
    width: 20px;
    height: 20px;
  }
`;

export const listBlockStyles = css`
  hive-list {
    display: block;
    font-size: var(--hive-font-base);
  }

  .hive-list-block-container {
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
  }
  .hive-list-block-container .hive-list-block-container {
    margin-top: 0;
  }
  .hive-list-rich-text-wrapper {
    position: relative;
    display: flex;
  }
  .hive-list-rich-text-wrapper rich-text {
    flex: 1;
  }

  .hive-list--checked {
    color: var(--hive-text-secondary-color);
  }

  ${listPrefix}
`;
